export default {
  labelItem: {
    borderBottom: '1px dashed currentColor',
    cursor: 'pointer',
  },
  requiredErrors: {},
};
